/**
 * Implements Mapbox API to add custom controls along Mapbox out of the
 * controls. This control provides expectes a callback handler in the
 * constructor which it calls whenver the checkbox changes.
 */
export default class MapSearchOnMoveControl {
    constructor(onClickSearchOnMove) {
        this._onClickSearchOnMove = this._onClickSearchOnMove.bind(this);
        this._onClickSearchOnMoveCallback = onClickSearchOnMove;
    }

    onAdd(map) {
        this._map = map;
        this._container = document.createElement('div');
        this._container.className = 'mapboxgl-ctrl mapboxgl-ctrl-text-group';

        this._searchOnMoveButton = document.createElement('input');
        this._searchOnMoveButton.type = 'checkbox';
        this._searchOnMoveButton.id = 'MapSearchOnMoveButton';
        this._searchOnMoveButton.name = 'MapSearchOnMoveButton';
        this._searchOnMoveButton.checked = true;
        this._searchOnMoveButton.setAttribute('aria-label', 'Search on drag');
        this._searchOnMoveButton.className = 'map-search-on-move-input';

        this._searchOnMoveLabel = document.createElement('label');
        this._searchOnMoveLabel.htmlFor = 'MapSearchOnMoveButton';
        this._searchOnMoveLabel.className = 'map-search-on-move-label';
        this._searchOnMoveLabel.appendChild(document.createTextNode('Search as I move the map'));

        this._searchOnMoveButton.addEventListener('click', this._onClickSearchOnMove);

        this._container.appendChild(this._searchOnMoveButton);
        this._container.appendChild(this._searchOnMoveLabel);

        return this._container;
    }

    _onClickSearchOnMove() {
        if (this._onClickSearchOnMoveCallback) {
            this._onClickSearchOnMoveCallback(this._searchOnMoveButton.checked);
        }
    }

    onRemove() {
        this._container.parentNode.removeChild(this._container);
        this._map = undefined;
    }
}
